import { IconButton, useTheme } from '@mui/material'
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined'
import WindowOutlinedIcon from '@mui/icons-material/WindowOutlined'
import BoxWithBackground from 'components/atoms/container/BoxWithBackground'
import RowStack from 'components/atoms/container/RowStack'
import colors from 'styles/colors'

const SwitchIcon = ({ active, setActive }) => {
  const theme = useTheme()
  const btnSx = {
    display: 'flex',
    padding: 0
  }

  const SwitchButton = ({ children, active }) => {
    return (
      <BoxWithBackground
        sx={{
          padding: 2,
          borderRadius: 2,
          width: 32,
          height: 32,
          backgroundColor: active
            ? colors.White
            : theme.palette.background.default,
          boxShadow: active ? `0px 1px 2px 0px ${colors.Grey200}` : 'none'
        }}>
        {children}
      </BoxWithBackground>
    )
  }

  return (
    <BoxWithBackground sx={{ padding: 2, borderRadius: 3 }}>
      <RowStack spacing={2}>
        <SwitchButton active={active}>
          <IconButton
            onClick={() => setActive(true)}
            sx={{
              ...btnSx,
              color: active ? theme.palette.primary.main : colors.Grey300
            }}
            data-testid='switch-on-btn'>
            <AccountTreeOutlinedIcon />
          </IconButton>
        </SwitchButton>

        <SwitchButton active={!active}>
          <IconButton
            onClick={() => setActive(false)}
            sx={{
              ...btnSx,
              color: !active ? theme.palette.primary.main : colors.Grey300
            }}
            data-testid='switch-off-btn'>
            <WindowOutlinedIcon />
          </IconButton>
        </SwitchButton>
      </RowStack>
    </BoxWithBackground>
  )
}

export default SwitchIcon
